import { useI18n as useVueI18n } from 'vue-i18n'
import { watch } from 'vue'

export function useI18n() {
  const { locale, t, availableLocales } = useVueI18n()

  const setLanguage = (lang: string) => {
    if (availableLocales.includes(lang)) {
      locale.value = lang
      localStorage.setItem('pdf-tools-language', lang)
    }
  }

  const toggleLanguage = () => {
    const newLang = locale.value === 'en' ? 'th' : 'en'
    setLanguage(newLang)
  }

  const currentLanguage = () => locale.value

  return {
    locale,
    t,
    setLanguage,
    toggleLanguage,
    currentLanguage,
    isThai: () => locale.value === 'th',
    isEnglish: () => locale.value === 'en',
  }
}
